<template>
    <div class="table-container center-column">
        <table class="table is-responsive-table is-fullwidth">
            <thead>
                <tr>
                    <th>#id</th>
                    <th>Name</th>
                    <th>Country</th>
                    <th>Client Type</th>
                    <th>Created</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="plan in plans">
                    <td>{{ plan.id }}</td>
                    <td><button class="button" @click="editPricePlan(plan)">{{ plan.name }}</button></td>
                    <td>{{ plan.country }}</td>
                    <td>{{ userTypeLabel(plan.user_type) }}</td>
                    <td>{{ plan.created_at }}</td>
                    <td v-if="isApproved(plan.status)">
                        <button v-if="isAdmin" @click="changePricePlanStatus(plan.id, disapproved)" class="button is-danger">Disapprove</button>
                        <span v-else="" class="has-text-primary">Approved</span>
                    </td>
                    <td v-else="">
                        <button v-if="isAdmin" @click="changePricePlanStatus(plan.id, approved)" class="button is-primary">Approve</button>
                        <span v-else="" class="has-text-danger">Not Approved</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import apiPricePlans from './../../../api/apiPricePlans'
    export default {
        data () {
            return {
                disapproved: null,
                approved: 1,
                userType: [
                    'Individual',
                    'Professional',
                    'Other'
                ]
            }
        },
        computed: {
            plans() {
                return this.$store.getters.getAllPricePlans
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            }
        },
        methods: {
            isApproved(status) {
                return this.approved === status
            },
            userTypeLabel(type) {
                return this.userType[type]
            },
            changePricePlanStatus(id, status){
                let data = { id: id, query: { status: status }}
                apiPricePlans
                    .updatePricePlanRequest(data)
                    .then((response) => {
                        this.$store.dispatch('getAllPricePlansRequest')
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            editPricePlan(plan) {
                this.$store.dispatch('setNewPricePlan', plan)
                this.$router.push({ path: '/plans/edit/' + plan.id,})
            }
        },
        created() {
            this.$store.dispatch('getAllPricePlansRequest')
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/PlansTable.vue